import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { SearchBox, SelectControllerVertical } from "@components";
import { ItemsListTableColumn } from "./ItemsListTableColumn";

import { useMetaData } from "@hooks/inventory/settings/useMetaData";
import { useLanguage } from "@hooks/useLanguage";

import { AssetsResponseType } from "@type/inventory/stock/assets";

import { getConvertedMetaData } from "@helpers/inventory/metaDataConvert";
import { TablePagination } from "@helpers/tablePagination";

import { SETTINGS_META_DATA } from "@constants/inventory/settings-meta-data";
import { useItemsList } from "@hooks/inventory/stock/itemsList/useItemsList";

const { CATEGORY, GROUP, BRAND } = SETTINGS_META_DATA;

export default function ItemsListTable() {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const { control, register, setValue } = useForm();

  const { handleQuery, itemsListState } = useItemsList();
  const { getData } = itemsListState;

  const { data, pagination } = getData || ({} as AssetsResponseType);

  const { data: categories } = useMetaData(CATEGORY);
  const { data: groups } = useMetaData(GROUP);
  const { data: brands } = useMetaData(BRAND);

  return (
    <Table
      header={{
        title: t("INVENTORY_STOCK.ITEMS_LIST.TABLE.HEADER"),
        badge: {
          label: `${pagination?.total || 0}`,
          size: "sm",
          type: "primary",
        },
      }}
      headerExtension={{
        leftComponents: [
          <div className="row pb-0 mb-0">
            <SelectControllerVertical
              label="INVENTORY_STOCK.ITEMS_LIST.TABLE.CATEGORY"
              name="category"
              register={{ ...register("categoryId") }}
              options={getConvertedMetaData(categories)}
              setValue={setValue}
              selectAction={(e) => handleQuery("categoryId", e)}
              control={control}
              cols={4}
              portal
              withoutLabel
            />

            <SelectControllerVertical
              label="INVENTORY_STOCK.ITEMS_LIST.TABLE.GROUP"
              name="group"
              register={{ ...register("groupId") }}
              options={getConvertedMetaData(groups)}
              setValue={setValue}
              selectAction={(e) => handleQuery("groupId", e)}
              control={control}
              cols={4}
              portal
              withoutLabel
            />

            <SelectControllerVertical
              label="INVENTORY_STOCK.ITEMS_LIST.TABLE.BRAND"
              name="group"
              register={{ ...register("brandId") }}
              options={getConvertedMetaData(brands)}
              setValue={setValue}
              selectAction={(e) => handleQuery("brandId", e)}
              control={control}
              cols={4}
              portal
              withoutLabel
            />
          </div>,
        ],
        rightComponents: [
          <SearchBox
            key="search"
            control={control}
            placeholder={t("INVENTORY_STOCK.ITEMS.TABLE.SEARCH")}
            handleQuery={handleQuery}
          />,
        ],
      }}
      columns={ItemsListTableColumn(t, language)}
      rows={(data as any[]) || []}
      pagination={TablePagination(pagination, handleQuery)}
    />
  );
}
